import React from "react";
import { useNavigate } from "react-router-dom";
import {
  LogOut,
  Inbox,
  FileText,
  Layers,
  LayoutDashboard,
} from "lucide-react";

export default function Dashboard() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* HEADER */}
      <header className="bg-black text-white px-6 py-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <LayoutDashboard size={26} /> Admin Dashboard
        </h1>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg"
        >
          <LogOut size={18} />
          Logout
        </button>
      </header>

      {/* CONTENT */}
      <div className="p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

        {/* MYSPACE REQUESTS */}
        <div className="bg-white rounded-2xl shadow hover:shadow-xl transition p-6">
          <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 text-white mb-4">
            <Inbox size={28} />
          </div>
          <h2 className="text-xl font-semibold">MySpace Requests</h2>
          <p className="text-gray-500 mt-2">
            Review & approve user submissions
          </p>
          <button
            onClick={() => navigate("/adminrequest")}
            className="mt-4 w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800"
          >
            Open Panel
          </button>
        </div>

        {/* ARTICLES */}
        <div className="bg-white rounded-2xl shadow hover:shadow-xl transition p-6">
          <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 text-white mb-4">
            <FileText size={28} />
          </div>
          <h2 className="text-xl font-semibold">Articles</h2>
          <p className="text-gray-500 mt-2">
            Manage published articles
          </p>
          <button
            onClick={() => navigate("/articlespanel")}
            className="mt-4 w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800"
          >
            Manage Articles
          </button>
        </div>

        {/* EDITIONS */}
        <div className="bg-white rounded-2xl shadow hover:shadow-xl transition p-6">
          <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-red-500 text-white mb-4">
            <Layers size={28} />
          </div>
          <h2 className="text-xl font-semibold">Editions</h2>
          <p className="text-gray-500 mt-2">
            Manage published editions
          </p>
          <button
            onClick={() => navigate("/editonsadmin")}
            className="mt-4 w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800"
          >
            Editions
          </button>
        </div>

        {/* MY SPACE */}
        <div className="bg-white rounded-2xl shadow hover:shadow-xl transition p-6">
          <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br from-green-500 to-emerald-600 text-white mb-4">
            <LayoutDashboard size={28} />
          </div>
          <h2 className="text-xl font-semibold">My Space</h2>
          <p className="text-gray-500 mt-2">
            Control magazine MySpace
          </p>
          <button
            onClick={() => navigate("/myspacepanel")}
            className="mt-4 w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800"
          >
            Edit MySpace
          </button>
        </div>

      </div>
    </div>
  );
}
